"use client";

import Cookies from "js-cookie";
import {
  LOCATION_OVERRIDE_COOKIE,
  USER_LOCATION_COOKIE,
} from "@/lib/user-context/constants";

const GEO_PRICING_LOC_QUERY_PARAM = "loc";
const COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/;

const getLocQueryParamCountry = (): string | null => {
  if (typeof window === "undefined") return null;
  const raw = new URLSearchParams(window.location.search).get(
    GEO_PRICING_LOC_QUERY_PARAM,
  );
  if (!raw) return null;
  const normalized = raw.trim().toUpperCase();
  return COUNTRY_CODE_PATTERN.test(normalized) ? normalized : null;
};

/** Country for geo-pricing only. Cookies first; `?loc=XX` is a dev/prod test fallback. */
export const getCheckoutGeoPricingCountryCode = (): string | null => {
  return (
    Cookies.get(LOCATION_OVERRIDE_COOKIE) ||
    Cookies.get(USER_LOCATION_COOKIE) ||
    getLocQueryParamCountry() ||
    null
  );
};
